import gsap from 'gsap';
import Lottie from 'lottie-web';
import LazyLoad from 'vanilla-lazyload';
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import inView from 'in-view';
import Plyr from 'plyr';
import ParallaxElement from './utils/parallax'
import Flickity from 'flickity';
import Splitting from 'splitting';
import modularLoad from 'modularload';
import { hyphenateHTML } from "hyphen/fr";
import Isotope from 'isotope-layout'

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, MorphSVGPlugin);

const HTML = document.querySelector('html');
let requestFrame = undefined;

class App {
  constructor() {
    const _ = this;
    HTML.classList.add('init-load')


    /**
     * Custom cursor
     */
    this.cursor = document.querySelector('.custom-cursor');
    if (this.cursor) {
      const _ = this;
      document.addEventListener('mouseenter', e => {
        gsap.to(this.cursor, { duration: 0.2, autoAlpha: 1 })
      })
      document.addEventListener('mouseleave', e => {
        gsap.to(this.cursor, { duration: 0.2, autoAlpha: 0 })
      })
      window.addEventListener('mousemove', cursorMove)

      function cursorMove(e) {
        gsap.set(_.cursor, { x: e.clientX, y: e.clientY, autoAlpha: 1 })
      }
    }

    /**
     * Loader
     */
    const loader = document.querySelector('.loader');
    if (loader) {
      this.tlLoader = gsap.timeline({
        paused: true,
        onStart: () => {
          window.scrollTo(0, 0)
        },
        onReverseComplete: () => {
          HTML.classList.add('no-scroll')
          HTML.classList.remove('open-menu')
        },
        onComplete: () => {
          HTML.classList.remove('no-scroll', 'open-menu')
          this.init();
        }
      });

      this.tlLoader.to(loader.querySelector('.baseline'), { duration: 0.3, autoAlpha: 0, y: '20%' }, 'start')
        .to(loader.querySelector('.point'), { duration: 0.4, ease: 'circ.inOut', scale: 0, transformOrigin: 'center center' }, 'start')
        .to(loader.querySelector('.letter-s'), { duration: 0.8, drawSVG: '0%', ease: 'power2.inOut' }, '-=0.2')
        .to(loader, { duration: 0.3, autoAlpha: 0 })
    }

    /**
     * Loader intern
     */
    const loaderIntern = document.querySelector('.loader-intern')
    if (loaderIntern) {
      this.tlLoaderIntern = gsap.timeline({
        paused: true,
        onStart: () => {
          setTimeout(() => {
            HTML.classList.remove('open-menu')
          }, this.tlLoaderIntern.duration() * 300)
        },
        onComplete: () => {
          window.scrollTo(0, 0)
          HTML.classList.add('no-scroll')
          HTML.classList.remove('open-menu')
        }
      })

      this.tlLoaderIntern.set(loaderIntern, { autoAlpha: 1 })
        .to(loaderIntern.querySelectorAll('.circle'), { duration: 0.8, ease: 'expo.in', stagger: 0.12, scale: 1 })
      // .to(loaderIntern.querySelector('svg'), { duration: 0.5, ease: 'circ.inOut', autoAlpha: 1, scale: 1 }, '-=0.5')
    }

    // Lazyload
    this.lazyload = new LazyLoad({
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: window.innerHeight * .8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest('figure');
          if (figure) figure.classList.add('media-is-loaded')
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest('figure');
        if (figure) figure.classList.add('media-is-loaded')
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });


    const logos = document.querySelectorAll('.main-logo .icon')
    if (logos) {
      logos.forEach(el => {

        Lottie.loadAnimation({
          container: el,
          path: templateUri + '/static/json/logo.json',
          renderer: 'svg',
          loop: true, // Optional
          autoplay: true,
        })
      })
    }

    // Menu toggle
    const toggleMenus = document.querySelectorAll('.toggle-menu')
    let currentBaseline = -1;
    if (toggleMenus) {
      const baselines = document.querySelectorAll('.main-nav .baseline');

      toggleMenus.forEach(menu => {
        menu.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          HTML.classList.toggle('open-menu')

          if (HTML.classList.contains('open-menu')) {
            if (baselines[currentBaseline]) {
              baselines[currentBaseline].classList.add('absolute', 'opacity-0', 'invisible')
            }

            const next = currentBaseline >= baselines.length - 1 ? 0 : currentBaseline + 1;
            baselines[next].classList.remove('absolute', 'opacity-0', 'invisible')

            currentBaseline = next
          }
        })
      })
    }

    this.load = new modularLoad({
      // enterDelay: this.tlLoader.duration() * 1000 + 1000,
      enterDelay: this.tlLoader.duration() * 500,
    })

    /*
    * PAGE IS ON LOADING
    */
    this.load.on('loading', (transition, oldContainer) => {
      // this.tlLoader.reverse()
      this.tlLoaderIntern.seek(0).play();

      HTML.classList.remove('page-is-loaded');
    })

    /**
     * PAGE IS LOADED
     */
    this.load.on('loaded', (transition, oldContainer, newContainer) => {
      window.scrollTo(0, 0)

      setTimeout(isFinish, 100)
      function isFinish() {
        if (_.tlLoaderIntern.duration() == _.tlLoaderIntern.time()) {
          HTML.classList.remove('no-scroll', 'open-menu')
          const loaderIntern = document.querySelector('.loader-intern');
          if (gtag) {
            gtag('js', new Date());
            gtag('config', 'G-MJHEWY8GV3');
          }

          // gsap.to(loaderIntern, {
          //   autoAlpha: 0, duration: 0.3, onComplete: () => {
          //     _.init();
          //   }
          // })
          gsap.set(loaderIntern, { autoAlpha: 0 })

          const form = newContainer.querySelector(".wpcf7 form");
          if (form) wpcf7.init(form);
          
          _.init();
        } else {
          setTimeout(isFinish, 100)
        }
      }
      // setTimeout(() => {
      //   // if (gtag) {
      //   //   gtag('js', new Date());
      //   //   gtag('config', 'G-MJHEWY8GV3');
      //   // }
      //   // this.tlLoader.play()
      // }, 150)
    })


    this.animFooter();

    this.tlLoader.play();
  }

  init() {
    if (this.cursor) {
      const links = document.querySelectorAll('a:not([href="#"])');

      if (links) {
        links.forEach(link => {
          link.addEventListener('mouseenter', e => {
            gsap.to(this.cursor, { duration: 0.3, ease: 'expo.out', scale: 1.5 })
          })
          link.addEventListener('mouseleave', e => {
            gsap.to(this.cursor, { duration: 0.3, ease: 'expo.out', scale: 1 })
          })
        })
      }
    }

    if (window.innerWidth <= 768) {
      const h1 = document.querySelectorAll('h1')
      if (h1) {
        h1.forEach(el => {
          hyphenateHTML(el.innerHTML).then(
            result => {
              el.innerHTML = result
            }
          );
        })
      }
    }

    const h2 = document.querySelectorAll('h2')
    if (h2) {
      h2.forEach(el => {
        hyphenateHTML(el.innerHTML).then(
          result => {
            el.innerHTML = result
          }
        );
      })
    }

    // Button magnetic
    const btnsMagnetic = document.querySelectorAll('[data-magnetic]');
    if (btnsMagnetic) {
      btnsMagnetic.forEach(el => {
        el.addEventListener('mousemove', function (e) {
          const pos = this.getBoundingClientRect();
          const mx = e.clientX - pos.left - pos.width / 2;
          const my = e.clientY - pos.top - pos.height / 2;

          gsap.to(this, { duration: 0.15, x: mx * 0.25 + 'px', y: my * 0.4 + 'px' })
        })

        el.addEventListener('mouseleave', function () {
          gsap.to(this, { duration: 0.15, x: 0, y: 0 })
        })
      });
    }

    // Pattern XS
    const shapes = document.querySelectorAll('.move-stroke')
    if (shapes) {
      shapes.forEach(el => {
        const tl = gsap.timeline({ repeat: -1, yoyo: true, paused: true });
        let paths = el.querySelectorAll('path');
        tl.to(paths, { duration: 4, drawSVG: "20% 80%", immediateRender: false }, "+=0.1")

        el.addEventListener('inview', e => {
          tl.play();
        })
        el.addEventListener('outview', e => {
          tl.pause();
        })
      })
    }

    // Animation H1
    const elts = document.querySelectorAll('h1, .title');
    if (elts) {
      const output = Splitting({ target: elts, by: 'chars' });
      output.forEach(el => {
        el.chars.forEach((char, i) => {
          char.innerHTML = '<span>' + char.innerHTML + '</span>'
        })
        el.el.classList.add('ready');
      })
    }


    //Parallax
    if (window.innerWidth > 768) {
      document.querySelectorAll('.js-parallax').forEach((el) => {
        let _p = new ParallaxElement(el, '.js-parallax', false)
        _p.teardown()
      })
    }

    this.lazyload.update();

    this.morphSVG();
    this.player();
    this.archive();
    this.playerPopup();
    this.bodymovin();
    this.sticky();
    this.carousel();
    this.carouselAutoscroll();
    this.tabs();
    this.blocksFix();
    this.inViewport();
  }

  morphSVG() {
    const elts = document.querySelectorAll('[data-morph]');

    if( elts ) {
      elts.forEach(el => {
          
        const path = el.querySelector('.main');
        if( path ) {
          el.dataset.orig = path.getAttribute('d');

          el.parentNode.addEventListener('mouseenter', () => {
            gsap.to(path, { morphSVG : el.dataset.morph, duration : 0.6, ease : "circ.inOut" })
          })
          el.parentNode.addEventListener('mouseleave', () => {
            gsap.to(path, { morphSVG : el.dataset.orig, duration : 0.6, ease : "circ.inOut" })
          })
        }
      })
    }
  }

  inViewport() {
    // In viewport
    inView.offset(window.innerHeight * .15);
    inView('.js-reveal:not(.is-visible)')
      .on('enter', function (elt) {
        elt.dispatchEvent(new Event('inview'))
        elt.classList.add('is-visible');
        elt.classList.remove('not-visible');

        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != '') {
          elt.play();
        }
      })
      .on('exit', function (elt) {
        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != '') {
          elt.pause();
        }
        elt.dispatchEvent(new Event('outview'))
        elt.classList.add('not-visible');
      })
  }

  bodymovin() {
    const elts = document.querySelectorAll('[data-bodymovin]');
    if (elts) {
      elts.forEach(el => {
        el.innerHTML = '';

        const l = Lottie.loadAnimation({
          container: el,
          path: el.dataset.bodymovin,
          renderer: 'svg',
          loop: true, // Optional
          autoplay: el.dataset.pause ? false : true,
        })

        l.addEventListener('DOMLoaded', function () {
          window.dispatchEvent(new Event('resize'));
        })

        window.addEventListener('resize', e => {
          const boundingWrapper = l.wrapper.getBoundingClientRect();

          if (l.animationData.w > boundingWrapper.width ||
            l.animationData.h > boundingWrapper.height) {
            const w = l.animationData.w > boundingWrapper.width ? boundingWrapper.width : boundingWrapper.height * l.animationData.w / l.animationData.h;
            const h = l.animationData.w > boundingWrapper.width ? boundingWrapper.width * l.animationData.h / l.animationData.w : boundingWrapper.height;
            l.renderer.svgElement.style.width = `${w}px`;
            l.renderer.svgElement.style.height = `${h}px`;
          }

        })

        el.lottie = l
      })
    }
  }

  archive() {
    const archives = document.querySelectorAll('.archive-main')
    if (archives) {
      archives.forEach(el => {
        const grid = el.querySelector('.isotope-grid');
        if( grid ) {
          const iso = new Isotope( grid, {
            hiddenStyle: {
              opacity: 0
            },
            visibleStyle: {
              opacity: 1
            },
            itemSelector: '.item',
            layoutMode: 'fitRows'
          });

          const filters = el.querySelectorAll('[data-filter]')
          let current = 0;
          if( filters ) {
            filters.forEach((filter, i) => {
              filter.addEventListener('click', e => {
                e.preventDefault();
                let counter = 0;

                if( filter.classList.contains('active')) return false;

                if( filters[current] ) filters[current].classList.remove('active')
                filter.classList.add('active');
                current = i;

                iso.arrange({
                  filter: function(item) {
                    const el = this ? this : item;

                    if( el && el.classList.contains(`type-${filter.dataset.filter}`) || filter.dataset.filter == '*') {
                      el.classList.add(counter%2 == 0 ? 'odd' : 'even');
                      el.classList.remove(counter%2 == 0 ? 'even' : 'odd');
                      counter++;
                      return true;
                    } else {
                      setTimeout(() => {
                        el.classList.remove('odd','even')
                      }, 400)
                    }
                  }
                });
              })
            })
          }
        }

        const cursor = el.querySelector('.cursor-archive');
        const items = el.querySelectorAll('.item figure');
        if (items) {
          items.forEach(item => {
            item.addEventListener('mouseenter', e => {
              gsap.to(cursor, { duration: 0.3, scale: 1, ease: 'back.out' });
              gsap.set(cursor, { zIndex: 9999 });
            })
            item.addEventListener('mouseleave', e => {
              gsap.to(cursor, {
                duration: 0.1, scale: 0, ease: 'circ.in', onComplete: () => {
                  gsap.set(cursor, { zIndex: 1 });
                }
              });
            })
          })
        }

        if (cursor) {
          el.addEventListener('mousemove', e => {
            const bounding = el.getBoundingClientRect();
            gsap.to(cursor, { duration: 0.05, left: e.clientX - bounding.x, top: e.clientY - bounding.y })
          })
          el.addEventListener('scroll', e => {
            gsap.to(cursor, { duration: 0.2, scale: 0, ease: 'circ.in' });
          })
        }
      })
    }
  }

  player() {
    const players = document.querySelectorAll('.player-custom')

    if (players) {
      players.forEach(player => {
        const video = player.querySelector('video')
        const p = new Plyr(video, {
          controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
          hideControls: false
        })

        const btn = player.querySelector('.btn-play')
        const overlay = player.querySelector('.overlay')

        if (btn) {
          btn.addEventListener('click', e => {
            e.preventDefault();
            p.play();
          })
        }

        p.on('play', () => {
          if (btn) gsap.to(btn, { scale: 0, ease: 'circ.inOut', duration: 0.5 })
          gsap.to(overlay, { autoAlpha: 0, duration: 0.3 })
          player.classList.add('playing')
        })
        p.on('pause', () => {
          if (btn) gsap.to(btn, { scale: 1, ease: 'circ.inOut', duration: 0.5 })
          gsap.to(overlay, { autoAlpha: 1, duration: 0.3 })
          player.classList.add('pause')
        })
      })
    }
  }

  playerPopup() {
    const players = document.querySelectorAll('.player')

    if (players) {
      players.forEach(player => {
        const popup = player.querySelector('.popup');
        const video = popup.querySelector('video')
        const p = new Plyr(video, {
          controls: ['play', 'progress', 'current-time', 'mute', 'volume']
        })

        const trigger = player.querySelector('.trigger-player')
        const close = player.querySelector('.close-player')
        const btn = close.querySelector('a')
        const cursor = player.querySelector('.cursor')
        const teaser = player.querySelector('.teaser')

        if (cursor && teaser && window.innerWidth > 768) {
          const initPos = cursor.getBoundingClientRect();

          teaser.addEventListener('mouseenter', e => {
            const bounding = teaser.getBoundingClientRect();
            if (this.cursor) {
              gsap.set(this.cursor, { autoAlpha: 0 });
            }
            gsap.to(cursor, {
              duration: .15, left: e.clientX - bounding.x, top: e.clientY - bounding.y, onComplete: () => {
                teaser.addEventListener('mousemove', moveCursor)
              }
            })
          })
          teaser.addEventListener('mouseleave', e => {
            const bounding = teaser.getBoundingClientRect();
            teaser.removeEventListener('mousemove', moveCursor)
            gsap.to(cursor, {
              duration: .4, left: '0', top: '15rem', ease: "power4.in", onComplete: () => {
                if (this.cursor) {
                  gsap.set(this.cursor, { autoAlpha: 1 });
                }
              }
            })
          })
          function moveCursor(e) {
            const bounding = teaser.getBoundingClientRect();
            gsap.to(cursor, { duration: 0.05, left: e.clientX - bounding.x, top: e.clientY - bounding.y })
          }
        }

        if (teaser) {
          async function playVideo() {
            try {
              await video.play();
            } catch (err) {
            }
          }
          
          function click(e) {
            e.preventDefault();

            if (window.innerWidth < 768) {
              video.play()
            } else {
              gsap.to(popup, {
                duration: 0.3, autoAlpha: 1, onComplete: () => {
                  playVideo();
                }
              });
            }
          }
          teaser.addEventListener('click', click)
          trigger.addEventListener('click', click)
        }

        if (close) {

          btn.addEventListener('click', e => {
            e.preventDefault();
            p.pause();

            gsap.to(popup, {
              duration: 0.3, autoAlpha: 0, onComplete: () => {
                p.currentTime = 0
              }
            });
          })
        }

        function mouseEnterClose(e) {
          gsap.to(btn, { duration: 0.3, autoAlpha: 1 });
        }
        function mouseLeaveClose(e) {
          gsap.to(btn, { duration: 0.3, autoAlpha: 0 });
        }
      })
    }
  }

  animFooter() {
    const animFooter = document.querySelector('.footer-anim');
    if (animFooter) {
      const txt = document.querySelector('.text-anim');
      const circle = animFooter.querySelector('.circle');
      const bg = circle.querySelector('.bg');
      const logo = circle.querySelector('.logo')

      const anim = Lottie.loadAnimation({
        container: logo,
        path: templateUri + '/static/json/logo.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
      })

      const tl = gsap.timeline({ repeat: -1, repeatDelay: 2 })
      let start = { duration: 1, y: '0%', bottom: '0', ease: "expo.inOut" }
      let reinit = { bottom: '100%', y: '100%' }

      if (window.innerWidth < 768) {
        start = { duration: 1, x: '-100%', left: '100%', ease: "expo.inOut" }
        reinit = { left: '0%', x: '0%' }
      }

      tl.to(circle, start)
        .to(txt, { duration: 0.3, autoAlpha: 1 }, 'step1')
        .to(bg, { duration: 0.3, scale: 1.5 }, 'step1')
        .set(bg, { borderRadius: 0, scale: 1 })
        .add(() => {
          anim.playSegments([46, 100], true) // Dédessine
        })
        .to(bg, { duration: 0.6, rotate: 90, scale: 0, ease: "circ.inOut" }, '+=0.7')
        .to(txt, { duration: 0.3, autoAlpha: 0.5 })
        .set(bg, { rotate: 0, borderRadius: '100%' }, 'reinit')
        .set(circle, reinit, 'reinit')
        .add(() => {
          anim.playSegments([120, 179], true) // Redessine
        }, '+=0.4')
        .to(bg, { duration: 0.4, scale: 1, ease: "circ.out" }, '+=0.1')
    }
  }

  carouselAutoscroll() {
    const elts = document.querySelectorAll('.carousel-autoscroll')
    if (elts) {
      elts.forEach(el => {
        const bg = el.querySelectorAll('.bg figure')
        const cursor = el.querySelector('.cursor')
        const carousel = el.querySelector('.carousel')

        if (carousel) {
          gsap.ticker.fps(30)

          carousel.addEventListener('mouseenter', e => {
            const bounding = el.getBoundingClientRect();
            gsap.set(cursor, { zIndex: 99999 });
            gsap.to(cursor, {
              duration: .1, left: e.clientX - bounding.x, top: e.clientY - bounding.y, onComplete: () => {
                el.addEventListener('mousemove', moveCursor)
              }
            })
          })
          carousel.addEventListener('mouseleave', e => {
            el.removeEventListener('mousemove', moveCursor)
            gsap.to(cursor, {
              duration: .4, left: '0%', top: '50%', ease: "power4.in", onComplete: () => {
                gsap.set(cursor, { zIndex: 1 });
              }
            })
          })
          function moveCursor(e) {
            const bounding = el.getBoundingClientRect();
            gsap.to(cursor, { duration: 0.05, left: e.clientX - bounding.x, top: e.clientY - bounding.y })
          }

          let current = -1;
          const flkty = new Flickity(carousel, {
            cellAlign: 'center',
            lazyLoad: 4,
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            on: {
              ready: function () {
                const f = this;
                pause();

                this.slider.addEventListener('mouseenter', e => {
                  // pause()
                  gsap.ticker.remove(play);
                })
                this.slider.addEventListener('mouseleave', e => {
                  // play()
                  gsap.ticker.add(play);
                })
              },
              scroll: function (index) {
                const next = Math.floor(-this.x / this.selectedSlide.outerWidth % 4);

                if (next != current &&
                  bg[next]) {
                  if (bg[current])
                    gsap.to(bg[current], { autoAlpha: 0, duration: 0.4 })

                  gsap.to(bg[next], { autoAlpha: 1, duration: 0.4 })
                  current = next
                }
              }
            }
          });

          flkty.on('pointerMove', function (e, pointer, moveVector) {
            moveCursor(e)
          });

          function play(time) {
            flkty.x = flkty.x - (window.innerWidth * 0.002);
            flkty.settle(flkty.x);
            // requestFrame = window.requestAnimationFrame(play);
          }

          function pause() {
            if (requestFrame) {
              window.cancelAnimationFrame(requestFrame)
              requestFrame = undefined;
            }
          }

          el.addEventListener('inview', e => {
            // play();
            gsap.ticker.add(play);
          })
          el.addEventListener('outview', e => {
            gsap.ticker.remove(play);
            // pause();
          })
        }
      })
    }
  }

  carousel() {
    const elts = document.querySelectorAll('.carousel-std')
    if (elts) {
      elts.forEach(el => {
        const cursor = el.querySelector('.cursor')

        el.addEventListener('mouseenter', e => {
          const bounding = el.getBoundingClientRect();
          if (this.cursor) {
            gsap.set(this.cursor, { autoAlpha: 0 });
          }
          gsap.to(cursor, {
            duration: .1, left: e.clientX - bounding.x, top: e.clientY - bounding.y, onComplete: () => {
              el.addEventListener('mousemove', moveCursor)
            }
          })
        })
        el.addEventListener('mouseleave', e => {
          el.removeEventListener('mousemove', moveCursor)
          gsap.to(cursor, {
            duration: .4, left: '85%', top: '40%', ease: "power4.in", onComplete: () => {
              if (this.cursor) {
                gsap.set(this.cursor, { autoAlpha: 1 });
              }
            }
          })
        })
        function moveCursor(e) {
          const bounding = el.getBoundingClientRect();
          gsap.to(cursor, { duration: 0.05, left: e.clientX - bounding.x, top: e.clientY - bounding.y })
        }

        const flkty = new Flickity(el.querySelector('.carousel'), {
          cellAlign: 'left',
          cellSelector: '.item',
          lazyLoad: 4,
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          on: {
            ready: function () {

            }
          }
        });

        flkty.on('pointerMove', function (e, pointer, moveVector) {
          moveCursor(e)
        });
      })
    }
  }

  sticky() {
    const stickys = document.querySelectorAll('[data-sticky]');

    // if (window.innerWidth < 1024) return;

    if (stickys) {
      stickys.forEach(el => {
        const parent = el.parentElement;

        window.addEventListener('scroll', (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();

          // Now sticky
          if (pPos.top <= 0) {
            el.style.width = `${pPos.width}px`

            if (pPos.bottom - pos.height <= 0) {
              el.style.position = 'absolute'
              el.style.top = `auto`
              el.style.bottom = `0px`
              el.style.left = `0px`
            } else {
              el.style.position = 'fixed'
              el.style.top = `0px`
              el.style.bottom = `auto`
              el.style.left = `${pPos.x}px`
            }
          } else {
            el.style.position = 'absolute'
            el.style.top = `0px`
            el.style.bottom = `auto`
            el.style.left = `0px`
            el.style.width = `100%`
          }
        })
      })
    }
  }

  tabs() {
    const elts = document.querySelectorAll('.tabs');
    if (elts) {
      elts.forEach(el => {
        const items = el.querySelectorAll('.item')
        const triggers = el.querySelectorAll('.list a')
        const imgs = el.querySelectorAll('.img')
        const tags = el.querySelectorAll('.tags')
        const bar = el.querySelectorAll('.scrollbar .bar')
        gsap.set(imgs[0], { clipPath: "polygon(0 13%, 100% 0%, 100% 87%, 0 100%)" })

        if (items) {
          let current = 0;

          if (triggers) {
            triggers.forEach((trigger, i) => {
              trigger.addEventListener('click', e => {
                e.preventDefault();
                if (items[i] && current != i) {
                  const pos = items[i].getBoundingClientRect();
                  gsap.to(document.querySelector('html, body'), { duration: 0.7, ease: 'expo.inOut', scrollTop: window.scrollY + pos.y })
                }
              })
            })
          }

          window.addEventListener('scroll', e => {
            if (bar) {
              const posBlocks = el.getBoundingClientRect();
              const percent = (1 - (posBlocks.bottom - window.innerHeight) / posBlocks.height) * 100;
              gsap.set(bar, { width: `${percent}%` });
            }

            items.forEach((item, i) => {
              const pos = item.getBoundingClientRect();
              const repere = window.innerHeight / 2

              if (pos.y <= repere && pos.bottom > repere && current != i) {
                if (tags[i]) {
                  gsap.to(tags[current], { duration: 0.5, autoAlpha: 0, marginTop: '-5rem', scaleY: '0' })
                  gsap.fromTo(tags[i], { marginTop: '5rem', scaleY: '0' }, { duration: 0.5, autoAlpha: 1, marginTop: '0rem', scaleY: '1' })
                }

                if (triggers) {
                  triggers[current].classList.remove('active')
                  // triggers[current].classList.add('txt-stroke', 'opacity-40')
                  triggers[i].classList.add('active')
                }

                current = i
              }
            })

          })
          window.dispatchEvent(new Event('scroll'))

          items.forEach((item, i) => {
            if (i == 0) return;
            gsap.to(imgs[i], {
              scrollTrigger: {
                trigger: item,
                scrub: true,
                start: "top bottom",
                end: "+=100%",
                onEnter: function ({ progress, direction, isActive }) {
                  gsap.set(imgs[Array.from(items).indexOf(item)], { zIndex: 2 });
                }
              },
              clipPath: "polygon(0 13%, 100% 0%, 100% 87%, 0 100%)",
              ease: "none"
            });
          })
        }
      })
    }
  }

  blocksFix() {
    const elts = document.querySelectorAll('.blocks-fix');
    if (elts) {
      elts.forEach(el => {
        const anims = el.querySelectorAll('.anims .anim');
        const blocks = el.querySelector('.blocks')
        const items = blocks.querySelectorAll('.item')
        const bar = el.querySelectorAll('.scrollbar .bar')
        let current = -1;

        window.addEventListener('scroll', e => {
          if (bar) {
            const posBlocks = blocks.getBoundingClientRect();
            const percent = (1 - (posBlocks.bottom - window.innerHeight) / posBlocks.height) * 100;
            gsap.set(bar, { height: `${percent}%` });
          }

          if (items) {
            items.forEach((item, i) => {
              const pos = item.getBoundingClientRect();
              const repere = window.innerHeight / 2

              if (pos.y <= repere && pos.bottom > repere && current != i) {
                if (anims[i]) {
                  if (current >= 0) {
                    gsap.to(anims[current], {
                      duration: 0.3, autoAlpha: 0, marginTop: '-5rem', onComplete: function () {
                        // On pause l'anim
                        const targets = this.targets();
                        if (targets[0].lottie) targets[0].lottie.stop()
                      }
                    })
                  }

                  // On joue l'anim
                  if (anims[i].lottie) anims[i].lottie.play()
                  gsap.fromTo(anims[i], { marginTop: '5rem' }, { duration: 0.3, autoAlpha: 1, marginTop: '0rem' })
                  current = i;
                }
              }
            })
          }
        })
        window.dispatchEvent(new Event('scroll'))
      })
    }
  }
}


window.addEventListener('DOMContentLoaded', () => {
  new App();
})